import type * as Types from 'app/types/graphql';

import { PromotionSelectFragmentDoc } from '../fragments/promotion.generated';
import { CouponSelectFragmentDoc } from '../fragments/coupon.generated';
import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import { appFetcher } from '~/api/utils/gatewayClient';
export type PromotionsActiveQueryVariables = Types.Exact<{
  shopPlatformId: Types.Scalars['ID']['input'];
  planIDs: Array<Types.Scalars['ID']['input']>;
}>;

export type PromotionsActiveQueryResponse = {
  promotionsActive?: Types.Maybe<
    Array<
      Pick<
        Types.Promotion,
        | 'id'
        | 'name'
        | 'type'
        | 'priority'
        | 'discountAmount'
        | 'discountUnit'
        | 'conditions'
        | 'startDate'
        | 'endDate'
        | 'enableForAllPlans'
      > & {
        coupons?: Types.Maybe<
          Array<
            Pick<Types.Coupon, 'id' | 'code'> & {
              promotion?: Types.Maybe<
                Pick<
                  Types.Promotion,
                  | 'id'
                  | 'name'
                  | 'type'
                  | 'priority'
                  | 'discountAmount'
                  | 'discountUnit'
                  | 'conditions'
                  | 'startDate'
                  | 'endDate'
                  | 'enableForAllPlans'
                > & { plans?: Types.Maybe<Array<Pick<Types.Plan, 'id' | 'name'>>> }
              >;
            }
          >
        >;
        plans?: Types.Maybe<Array<Pick<Types.Plan, 'id' | 'name'>>>;
      }
    >
  >;
};

export const PromotionsActiveDocument = `
    query PromotionsActive($shopPlatformId: ID!, $planIDs: [ID!]!) {
  promotionsActive(shopPlatformID: $shopPlatformId, planIDs: $planIDs) {
    ...PromotionSelect
    coupons {
      ...CouponSelect
    }
  }
}
    ${PromotionSelectFragmentDoc}
${CouponSelectFragmentDoc}`;

export const usePromotionsActiveQuery = <TData = PromotionsActiveQueryResponse, TError = unknown>(
  variables: PromotionsActiveQueryVariables,
  options?: UseQueryOptions<PromotionsActiveQueryResponse, TError, TData>,
) => {
  return useQuery<PromotionsActiveQueryResponse, TError, TData>(
    ['PromotionsActive', variables],
    appFetcher<PromotionsActiveQueryResponse, PromotionsActiveQueryVariables>(
      PromotionsActiveDocument,
      variables,
    ),
    options,
  );
};

usePromotionsActiveQuery.getKey = (variables: PromotionsActiveQueryVariables) => [
  'PromotionsActive',
  variables,
];
